/** 게임 안 계정 화면 (DESIGN 14.111). 인증 실행은 `ui/auth.js`가 맡는다. */
import { S, esc } from '../../core/state.js';
import { sec, muted } from './common.js';

export function render() {
  const a = S.auth || {};
  const n = S.naverAuth || {};
  const connected = [a.linked ? 'Google' : '', n.linked ? '네이버' : ''].filter(Boolean);
  const checking = !a.ready || !n.ready;
  const uncertain = !connected.length && (checking || a.bad || n.bad);
  const state = connected.length ? '계정에 기록 보관 중' : uncertain ? '연결 상태 확인 중' : '게스트로 플레이 중';
  const detail = connected.length ? connected.join(' · ') + ' 계정으로 다른 기기에서도 같은 캐릭터·창고·도감을 이어간다.'
    : uncertain ? '연결 상태를 아직 확인하지 못했다. 아래 서비스별 안내를 확인해 달라. 지금 캐릭터로 계속 플레이할 수 있다.'
    : '지금 바로 플레이할 수 있다. 브라우저 데이터를 지우면 기록을 다시 찾기 어려우니, 보관하려면 아래에서 계정을 연결한다.';

  let google = muted(a.linked ? '현재 유니지 계정에 연결돼 있다.' : a.ready ? (a.enabled ? '현재 기록에 Google을 연결할 수 있다.' : 'Google 연결은 준비 중이다.') : 'Google 연결 상태를 확인하는 중…');
  if (a.enabled) {
    google += `<div class="accountauth"><div id="accountgooglebtn"></div>`
      + `<span id="accountauthnote" class="${a.bad ? 'bad' : ''}">${esc(a.message || (a.linked ? 'Google 계정이 연결돼 있다.' : '아래에서 Google 계정을 선택해 연결한다.'))}</span>`
      + (a.linked
        ? `<button id="accountauthlogout" type="button" onclick="act.authLogout()">이 기기에서 로그아웃</button>`
        : '')
      + `</div>`;
  } else {
    google += muted('현재 캐릭터로 계속 플레이할 수 있다.');
  }

  const naver = `<div class="accountauth"><button id="accountnaverbtn" class="naverlogin" type="button"${!n.enabled || n.busy || n.linked ? ' disabled' : ''}>`
    + `${n.linked ? '✓ 네이버 계정 연결됨' : '현재 계정에 네이버 연결'}</button>`
    + `<span id="accountnavernote" class="navernote${n.bad ? ' bad' : ''}" role="status" aria-live="polite">${esc(n.message || '네이버 연결 상태를 확인하는 중…')}</span>`
    + `<button id="accountnaverretry" class="naverretry" type="button"${n.retry ? '' : ' hidden'}>네이버 연결 다시 확인</button>`
    + (n.linked ? `<button id="accountnaverunlink" type="button"${n.unlinkEnabled ? '' : ' disabled'}>네이버 연결 해제</button>` + (n.unlinkReason ? `<span class="navernote">${esc(n.unlinkReason)}</span>` : '') : '')
    + (n.linked && !a.linked ? `<button type="button" onclick="act.authLogout()">이 기기에서 로그아웃</button>` : '')
    + `</div>`;

  const character = sec('캐릭터', `<div class="item accountchoice"><span class="nm">다른 캐릭터로 이어하기<br><span class="qt">캐릭터와 계정 정보는 유지된다</span></span><button onclick="act.logout()">캐릭터 선택</button></div>`);
  return `<section class="ux-hero accountstate" role="status"><p class="ux-kicker">캐릭터와 기록</p><h3 class="ux-title">${state}</h3><p class="ux-summary">${detail}</p></section>`
    + (connected.length ? character : '')
    + sec(connected.length ? 'Google 연결 살펴보기' : 'Google로 기록 보관하기', google)
    + sec('네이버 계정', naver)
    + (connected.length ? '' : character)
    // 2026-10-21 — 요점 한 줄 + [자세히]
    + '<details class="ux-details" id="account-guide"><summary>연결·로그아웃 안내</summary><p>' + `
      Google 또는 네이버 계정을 연결하면 다른 기기에서도 <b>캐릭터·창고·도감·세계 참여 이력</b>을 이어갈 수 있다.<br>
      같은 유니지 계정에 두 서비스를 함께 연결할 수 있다. 다른 계정의 캐릭터와 아이템은 합쳐지지 않는다.<br>
      <b>이 기기에서 로그아웃</b>은 계정 연결과 게임 기록을 유지한다.` + '</p></details>';
}
